import React from "react";

export const CyberRodentIcon = () => {
  return (
    <svg
      width="5"
      height="13"
      viewBox="0 0 5 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.50302 13L1.49287 11.3466L1.90885 4.19838L2.48874 4.29939L3.09672 4.19347L3.51318 11.3466L2.50302 13ZM0 2.84127L5.67664e-06 3.42584L2.50002 3.861L5 3.42587V2.8413H3.01845L2.91007 0.982467C3.06948 0.882284 3.17264 0.725214 3.17268 0.548019C3.17268 0.24535 2.87287 3.11764e-06 2.50304 0C2.1332 -1.55881e-06 1.8334 0.245341 1.8334 0.548011C1.8334 0.725129 1.93651 0.882148 2.09579 0.982332L1.98744 2.84126L0 2.84127Z"
        fill="#C6B7FF"
      />
    </svg>
  );
};

